"use strict";
/* tslint:disable */
var TTeaserSPSlipMode = (function () {
    "use strict";
    var api = {};
    // Overrides TeaserSPSlipMode
    api.updateView = function () {
        TUniSlip.buildView();
    };
    // Template logic splitter
    api.buildOptions = function (selections) {
        return TMultiOptions.buildTeaser(this, selections);
    };
    // Adapter for Array.push template implementation
    api.buildSelectionInnerView = function (selection, selectionUpdated) {
        return TBuildLine.buildInnerView(selection, this, { buildInner: true, updated: selectionUpdated, isSP: true });
    };
    api.buildHeader = function () {
        return "";
    };
    return api;
}());
window.TTeaserSPSlipMode = TTeaserSPSlipMode;
//# sourceMappingURL=TTeaserSPSlipMode.js.map